import {
  validatePasswordLength,
  validatePasswordLowercase,
  validatePasswordNumber,
  validatePasswordSpecialCharacter,
  validatePasswordUppercase,
} from 'src/validators';
import i18next from '../../../i18n';

type Rule = {
  key: string;
  message: string;
  translatedMessage: () => string;
  validate: (input: string) => boolean;
};

export const newPasswordRules: Rule[] = [
  {
    key: 'password-length',
    message: 'Between 10 and 30 characters',
    translatedMessage() {
      return i18next.t('validatorsNew.passwordLength');
    },
    validate: validatePasswordLength,
  },
  {
    key: 'password-uppercase',
    message: 'At least one uppercase letter',
    translatedMessage() {
      return i18next.t('validatorsNew.passwordUppercase');
    },
    validate: validatePasswordUppercase,
  },
  {
    key: 'password-lowercase',
    message: 'At least one lowercase letter',
    translatedMessage() {
      return i18next.t('validatorsNew.passwordLowercase');
    },
    validate: validatePasswordLowercase,
  },
  {
    key: 'password-number',
    message: 'At least one number',
    translatedMessage() {
      return i18next.t('validatorsNew.passwordNumeric');
    },
    validate: validatePasswordNumber,
  },
  {
    key: 'password-special-character',
    message: 'At least one special character',
    translatedMessage() {
      return i18next.t('validatorsNew.passwordSpecialCharacter');
    },
    validate: validatePasswordSpecialCharacter,
  },
];

export const validateNewPassword: (
  newPassword: string,
) => [string, string, boolean, string][] = (newPassword) =>
  newPasswordRules.map(({ message, key, validate, translatedMessage }) => [
    message,
    key,
    validate(newPassword),
    translatedMessage(),
  ]);
